import '@babel/polyfill';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './stores';
import localeFr from './i18n/fr';
import localeEn from './i18n/en';
import moment from 'moment';
import VueResource from 'vue-resource';

// I18n
// ----
Vue.use(VueI18n);
const messages = {
    fr: localeFr,
    en: localeEn,
};

// Create VueI18n instance with options
const availableLanguages = Object.keys(messages);
const navigatorLanguage  = (navigator.language || navigator.userLanguage).substr(0, 2);
const locale             = (availableLanguages.indexOf(navigatorLanguage) !== -1) ? navigatorLanguage : 'en';

const i18n = new VueI18n({
    locale:  locale, // set locale
    messages, // set locale messages
});

// Locale de Moment.js
// -------------------
moment.locale(locale);

// Roboto fontface
// ---------------
require('roboto-fontface/css/roboto/roboto-fontface.css');

// Vue Resource for HTTP request
// -----------------------------
Vue.use(VueResource);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
